module.exports = __webpack_public_path__ + "img/player-play.9c3168e6.svg";